import { createRouter, createWebHistory } from 'vue-router'
import Clients from '../views/Clients.vue'
import GravyLogin from "@/views/GravyLogin";
import store from '../store'
import firebase from "firebase";
import Logout from "@/views/Logout";
import ClientDetail from "@/views/ClientDetail";
import Testing from "@/views/Testing";
import SendEmail from "@/views/SendEmail";
import gravyAxios from "@/plugins/axios";
import jwt_decode from "jwt-decode";
import FourOhFour from "@/views/FourOhFour";

const routes = [
  {
    path: '/',
    name: 'Home',
    component: SendEmail,

  },
  {
    path: '/login',
    name: 'Login',
    component: GravyLogin
  },
  {
    path: '/send-email',
    name: 'Send Email',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/SendEmail.vue')
  },
  {
    path: '/tasks',
    name: 'Tasks',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Tasks.vue')
  },
  {
    path: '/clients',
    name: 'Clients',
    component: Clients
  },
  {
    path: '/client/:id',
    name: 'Client Detail',
    component: ClientDetail
  },
  {
    path: '/logs',
    name: 'Logs',
    component: () => import('../views/Logs.vue')
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('../views/Users.vue')
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout
  },
  {
    path: '/test',
    name: 'Test',
    component: Testing
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component:  FourOhFour
  },
]


// For some reason can't get this to work? The router.beforeEach function does what we need though...
// const defaultAuthGuard = (to, from, next) => {
//
//   console.log("Default Auth Guard " + store.getters.isLoggedIn)
//    !store.getters.isLoggedIn ? next('/login') : null
// }
//
//
//
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach( (to, from, next) => {
  if (to.name === 'Logout') {
    firebase.auth().signOut()
        .then(result => {
          next('/login')
          // this.$router.push({name: "Login"})
        })
  }
  if (to.name !== 'Login') {
    const token = localStorage.getItem('gravyauth')
    if (token && typeof token !== 'null') {
      const decoded = jwt_decode(token)
      const exp = decoded.exp
      if (Date.now() >= exp * 1000) {

        firebase.auth().signOut()
      }
    } else {
      firebase.auth().signOut()
    }

    firebase.auth().onAuthStateChanged(async user => {
      // store.commit('setUser', user)
      if (!user) {
        next({name: 'Login'})
      } else {
        if (user.providerData[0].photoURL) {
          const profilePicture = user.providerData[0].photoURL
          store.dispatch('setProfilePicture', profilePicture)

        }
        const storeUser = store.getters.getGravyUser
        storeUser ? null : await store.dispatch('getGravyUser')
        if (to.name === 'Users') {
          const storeUserRole = store.getters.getGravyUserRole
          if (storeUserRole !== "Admin") {
            next("/send-email")
          }
        }
        const token = localStorage.getItem('gravyauth')
        let result = await user.getIdToken(false)
        if (result !== token) {
          // gravyAxios.defaults.headers.common['Authorization'] = `Bearer: ${result}`
          // localStorage.setItem('gravyauth', result)
          store.commit('setUser', user)
        }
        next()
      }
    })
  } else {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        next('/send-email')
      } else {
        next()
      }
    })
  }
  // if (to.name !== 'Login' && !store.getters.isLoggedIn) next({ name: 'Login' })
  // else next()

})
export default router
